import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useErrorsStore = defineStore('errorsStore', () => {
  const error = ref({
    title: '',
    description: '',
    url: ''
  })

  const setError = ({ title, description, url }) => {
    error.value = { title, description, url }
  }

  const resetErrorObject = () => {
    useErrorsStore().$reset()
  }

  return {
    error,
    setError,
    resetErrorObject
  }
})
